var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQsr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "avatar/location/QSR") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.025 0.001 1.025 9.001 7.024 9.001 8.025 0.001"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "avatar/location/QSR",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#E04622",
    points: "11 26.001 69 26.001 69 11.001 11 11.001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1019,33.0004 C52.5709,33.0004 50.2369,33.5374 48.1019,34.5874 L48.1019,47.0004 L62.1019,47.0004 L62.1019,34.5874 C59.9679,33.5374 57.6339,33.0004 55.1019,33.0004",
    id: "Fill-2",
    fill: "#F76E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9809,48.0004 L51.8769,48.0004 C51.2119,48.0004 50.7329,47.3634 50.9159,46.7254 L52.1369,42.4504 C52.3819,41.5924 53.1669,41.0004 54.0599,41.0004 L62.1649,41.0004 C62.8289,41.0004 63.3079,41.6364 63.1259,42.2744 L61.9049,46.5494 C61.6589,47.4074 60.8749,48.0004 59.9809,48.0004",
    id: "Fill-4",
    fill: "#E04622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1019,27.0004 C59.1019,24.7904 57.3119,23.0004 55.1019,23.0004 C52.8919,23.0004 51.1019,24.7904 51.1019,27.0004 C51.1019,29.2104 52.8919,31.0004 55.1019,31.0004 C57.3119,31.0004 59.1019,29.2104 59.1019,27.0004 Z",
    id: "Fill-7",
    fill: "#EFC59C"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#DEDFE1",
    points: "11 69 69 69 69 47 11 47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,40 L33,40 L33,32 C33,30.897 33.897,30 35,30 L38,30 L38,32 L35,32 L35,40 Z",
    id: "Fill-1",
    fill: "#E04622"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(30.000000, 37.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Clip-16",
    fill: "#DEDFE1",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.0004,2.0004 C8.0004,1.3554 6.2094,0.8334 4.0004,0.8334 C1.7904,0.8334 0.0004,1.3554 0.0004,2.0004 L0.0004,0.0004 L8.0004,0.0004 L8.0004,2.0004 Z",
    id: "Fill-15",
    fill: "#BEC0C2",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-18",
    fill: "#DEDFE1",
    points: "37.9828 35.0004 29.9828 35.0004 28.9828 37.0004 38.9828 37.0004"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0004,45.0004 C34.0004,42.7904 32.1304,41.0004 29.0004,41.0004 C25.8694,41.0004 24.0004,42.7904 24.0004,45.0004 L34.0004,45.0004 Z",
    id: "Fill-20",
    fill: "#DFA772"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    fill: "#000000",
    points: "40.9525 47.0004 20.0555 47.0004 19.0555 45.0004 41.9525 45.0004"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.551,44.0004 L55.8769,44.0004 C55.2119,44.0004 54.7329,43.3634 54.9159,42.7254 L56.1369,38.4504 C56.3819,37.5924 57.1669,37.0004 58.0599,37.0004 L66.1649,37.0004 C66.8289,37.0004 67.3079,37.6364 67.1259,38.2744 L65.9049,42.5494 C65.6589,43.4074 64.8749,44.0004 63.9809,44.0004 L62.551,44.0004 L62.551,47 L59.551,47 L59.551,44.0004 Z",
    id: "Path",
    fill: "#000000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQsr);
export default __webpack_public_path__ + "static/media/QSR.4fffb997b686328eee1ae55cccb65e75.svg";
export { ForwardRef as ReactComponent };